import { useUtils } from "@/app/hooks/useUtils";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useRef, useState } from "react";

export default function ViewRefundDetails({ orders }) {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { veticDateFormat } = useUtils();

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <div>
      <div className="text-blue-600 text-xs font-medium cursor-pointer" onClick={() => setOpen(true)}>
        Refund Details
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all 
                sm:max-w-3xl
                sm:w-full sm:p-6`}
                >
                  <div className="bg-white p-4 rounded-lg ">
                    <div className="flex items-center justify-between mb-4">
                      <p className="text-lg font-semibold">Refund History</p>
                      <XMarkIcon
                        className="w-5 h-5 text-gray-600 hover:text-red-500 cursor-pointer"
                        onClick={() => setOpen(false)}
                      />
                    </div>

                    <hr className="mb-4" />

                    {orders?.refund_details &&
                      <div className="space-y-4">
                        <div className="flex items-start">
                          <p className="w-1/3 text-sm font-medium text-gray-600">Refund Status</p>
                          <p className={` p-1 rounded-full px-2 ${orders?.refund_details?.refund_status?.toLowerCase() === "processed"
                            ? "bg-green-100 text-green-700"
                            : "bg-yellow-100 text-red-600"}
              `}>{orders?.refund_details?.refund_status || "-"}</p>
                        </div>

                        <div className="flex items-start">
                          <p className="w-1/3 text-sm font-medium text-gray-600">Refund Amount</p>
                          <p className="text-sm">{orders?.refund_details?.refund_amount ? `${orders?.refund_details?.refund_amount} /-` : "-"}</p>
                        </div>

                        <div className="flex items-start">
                          <p className="w-1/3 text-sm font-medium text-gray-600">Bank Reference Number</p>
                          <p className="text-sm break-words">{orders?.refund_details?.rrn || "-"}</p>
                        </div>

                        <div className="flex items-start">
                          <p className="w-1/3 text-sm font-medium text-gray-600">Refund Initiation Date</p>
                          <p className="text-sm">
                            {orders?.refund_details?.created_at ? veticDateFormat(orders?.refund_details?.created_at) : "-"}
                          </p>
                        </div>
                      </div>}
                    <div className={` ${orders?.refund_history?.length > 1 && "overflow-auto h-[600px]"}`}>

                      {orders?.refund_history?.length > 0 && (
                        orders?.refund_history?.map((refund, index) => (
                          <div
                            key={refund.refund_id}
                            className={`border border-gray-200 rounded-md p-4 shadow-sm bg-gray-50 mt-4`}
                          >
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-sm font-semibold">Refund #{index + 1}</p>
                              <span
                                className={`text-xs px-2 py-1 rounded-full font-medium
                ${refund.status?.toLowerCase() === "processed"
                                    ? "bg-green-100 text-green-700"
                                    : "bg-yellow-100 text-red-600"}
              `}
                              >
                                {refund?.status}
                              </span>
                            </div>

                            <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
                              <div>
                                <p className="font-medium">Amount</p>
                                <p>{refund?.amount} /-</p>
                              </div>

                              <div>
                                <p className="font-medium">Refund ID</p>
                                <p className="break-all">{refund?.refund_id}</p>
                              </div>

                              <div>
                                <p className="font-medium">RRN</p>
                                <p>{refund?.rrn || "-"}</p>
                              </div>

                              <div>
                                <p className="font-medium">Reason</p>
                                <p>{refund?.notes?.reason || "-"}</p>
                              </div>

                              <div>
                                <p className="font-medium">Processed Speed</p>
                                <p>{refund?.speed_processed}</p>
                              </div>

                              <div>
                                <p className="font-medium">Requested Speed</p>
                                <p>{refund?.speed_requested}</p>
                              </div>

                              <div>
                                <p className="font-medium">Process Type</p>
                                <p className="capitalize">{refund?.process?.replace(/_/g, " ")}</p>
                              </div>

                              <div>
                                <p className="font-medium">Sub Order ID</p>
                                <p>{refund?.sub_order_id}</p>
                              </div>

                              <div>
                                <p className="font-medium">Created At</p>
                                <p>{veticDateFormat(refund?.created_at)}</p>
                              </div>

                              <div>
                                <p className="font-medium">Updated At</p>
                                <p>{veticDateFormat(refund?.updated_at)}</p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) }


                    </div>
                  </div>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
